export const BRAND = process.env.REACT_APP_BRAND || 'nature-power';
export const GAME_BASE_URL = process.env.REACT_APP_GAME_BASE_URL || 'https://reaktor-nature-power.sourcedupays.online';
